import React, { useEffect, useRef } from 'react';
import { prepareMediaHtml, hydrateMedia } from './protectedMedia';

export const ProtectedHtml = ({ html, ...props }) => {
  const ref = useRef(null);
  useEffect(() => { const urls = new Map(); ref.current.innerHTML = prepareMediaHtml(html); hydrateMedia(ref.current, urls); return () => { urls.forEach(URL.revokeObjectURL); }; }, [html]);
  return <div ref={ref} {...props} />;
};